import type { AutocompleteProps } from '@mui/material';
import { namedByPlaceholder } from '~/components/forms/autocomplete-label';
import { StripedContainer } from '~/components/striped-container';
import { useUniqueId } from '~/hooks/unique-id';
import { Autocomplete, Label, TextField } from './styles';

export interface StripedAutocompleteProps {
  placeholder?: string;
  label?: string;
  onChange: AutocompleteProps<string, true, false, true>['onChange'];
  values: string[];
}

export const StripedAutocomplete = ({
  placeholder,
  label,
  onChange,
  values,
}: StripedAutocompleteProps) => {
  const labelId = useUniqueId('striped-autocomplete-label');
  return (
    <StripedContainer>
      {label && <Label id={labelId}>{label}</Label>}
      <Autocomplete
        freeSolo
        fullWidth
        multiple
        onChange={onChange}
        open={false}
        options={[]}
        // The caption above is the label; the placeholder only names the input when there is none.
        renderInput={(params) => {
          const input = namedByPlaceholder(params, placeholder, label != null);
          return (
            <TextField
              {...input}
              inputProps={{ ...input.inputProps, 'aria-labelledby': label ? labelId : undefined }}
            />
          );
        }}
        value={values}
      />
    </StripedContainer>
  );
};
